export default __webpack_public_path__ + "static/media/aws@2.a5deae65.png";